import { Component, OnInit } from '@angular/core';
import {Constants} from '../../constants/ebtq-constants';
import {Title} from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'app-reverse-mortage',
  templateUrl: './reverse-mortgage.component.html',
  styleUrls: ['./reverse-mortgage.component.scss']
})
export class ReverseMortgageComponent implements OnInit {

  isAdmin = false;
  isDeveloper = false;
  rmIntView = false;
  rmIntUpdate = false;
  rmExtSerView = false;
  rmExtDelView = false;
  rmExtDelUpdate = false;
  rmExtSerpdate = false;
  servicingBannerMsg: string;
  deliveryBannerMsg: string;
  servicingIndicator: string;
  deliveryIndicator: string;
  rmIndicator:string;
  title = 'Reverse Mortgage';

  constructor(private titleService: Title) { }

  ngOnInit(): void {

    this.titleService.setTitle(this.title);

    /** get the session roles and show or hide from user **/
    this.isAdmin = JSON.parse(sessionStorage.getItem('isAdmin'));
    this.isDeveloper = JSON.parse(sessionStorage.getItem('isDeveloper'));
    this.rmIntView = JSON.parse(sessionStorage.getItem('isRMInternal_View'));
    this.rmIntUpdate = JSON.parse(sessionStorage.getItem('isRMInternal_Update'));
    this.rmExtSerView = JSON.parse(sessionStorage.getItem('isRMExternal_Servicing_View'));
    this.rmExtSerpdate = JSON.parse(sessionStorage.getItem('isRMExternal_Servicing_Update'));
    this.rmExtDelView = JSON.parse(sessionStorage.getItem('isRMExternal_Delivery_View'));
    this.rmExtDelUpdate = JSON.parse(sessionStorage.getItem('isRMExternal_Delivery_Update'));


    sessionStorage.setItem('currentmenuOption', 'reverseMortgage');


    this.servicingBannerMsg = sessionStorage.getItem(Constants.SERVICING_BAN_MSG);
    this.deliveryBannerMsg = sessionStorage.getItem(Constants.DELIVERY_BAN_MSG);



    this.servicingIndicator = sessionStorage.getItem('ServicingSystemIndicator');
    this.deliveryIndicator = sessionStorage.getItem('DeliverySystemIndicator');
    this.rmIndicator = sessionStorage.getItem('RMSystemIndicator');



  }

}
